/*
 * Module for the member detail screen
*/

rs.module("ui/content/actuaryextractbatches/memberdetail",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, actuaryExtractDetailMemberKey) {

            // on plan change, reload plan breakdown
            $.js(jsSelectors.planSelect).change(function () {

                $.js(jsSelectors.loadingSpinner).show();

                $.get(
                    backendUrls.getPlanDetail,
                    {
                        planKey: $(this).val(),
                        actuaryExtractDetailMemberKey: actuaryExtractDetailMemberKey
                    }).done(function (result) {
                        $.js(jsSelectors.planDetail).html(result);
                    }).always(function () {
                        $.js(jsSelectors.loadingSpinner).hide();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);